import type { CompaniesRegistrar } from '../../../../../models/company.js';

export type BankDetails = NonNullable<CompaniesRegistrar['bankDetails']>;

/** The bank account a company added in Connect to Your Bank, kept on its BANK_VALIDATION registrar. */
export const bankValidationDetails = (registrars?: CompaniesRegistrar[] | null): BankDetails | undefined =>
  registrars?.find((registrar) => registrar.registrarType === 'BANK_VALIDATION')?.bankDetails ?? undefined;

/** Six digits shown as NN-NN-NN, anything else as given. For display only. */
export const formatSortCode = (sortCode?: string | null): string => {
  const digits = (sortCode ?? '').replace(/\D/g, '');
  return digits.length === 6 ? `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}` : (sortCode ?? '');
};
